var _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M102.8 62.4s11.3 6.5 22.3 0M129.6 73.7s-7.7-6.4-3-23c2.4-8.6 9.9-28.8 9.9-28.8-6.9 2.5-15.6 10.2-15.6 10.2-3.5-6.1-11.7-10.2-11.7-10.2l-.5 15.9c-9.1-8.5-21.5-8.1-21.5-8.1.4.2 27.2 27.5 9.9 44.1-11 10.6-20.5 17.5-25.9 26.1h.9c21.1 0 38.2 17.1 38.2 38.2 0 6.7-1.7 13-4.8 18.5 2.5.3 5 .4 7.7.4 33.2 0 47.2-20.8 47-39.9-.1-19.4-13.4-26.9-30.6-43.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M71.3 99.7c-20.7.5-37.3 17.4-37.3 38.2 0 21.1 17.1 38.2 38.2 38.2 14.4 0 26.9-8 33.4-19.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M78.1 131.5s-1-6-6-6-6.3 6-6.3 6l12.9 9.8M66.4 141.3s1 6 6 6 6.3-6 6.3-6M72.2 120.3v5.2M72.2 147.3v5.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 72.2,
    cy: 137.9,
    r: 29
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 52.7,
    cy: 137.9,
    r: 3.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 91.5,
    cy: 137.9,
    r: 3.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashbox);
export default __webpack_public_path__ + "static/media/cashbox.9c25411c9ac1739bda91f8d0dbbc6c0c.svg";
export { ForwardRef as ReactComponent };